<template></template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { vueData } from '../../VueData';

  @Component
  export default class RootPage extends Vue {
    mounted() {
      const user = vueData.user;
      if (user) this.$router.replace('/dashboard');
      else this.$router.replace('/login');
    }
  }
</script>
